import listEmbeddableMixin from "@/mixins/embeddable/resource/listEmbeddableMixin";
import ProductionOrderStepEmbeddable from "@/views/modules/production/ProductionOrder/embeddable/ProductionOrderStepEmbeddable";

export default {
    components:{ProductionOrderStepEmbeddable},
    mixins: [listEmbeddableMixin],
    data() {
        return {
            path: "production/order-step", //Override somente de front-end, por tanto irá utilizar o mesmo path que o original da página por padrão
        }

    },
    async mounted() {

        /*Declarar todos os campos no padrão que podem ser utilizados*/

        const formDefault = {
            default: "", //NÃO ESQUECER DOS CAMPOS PADROES DE BUSCA COMO DEFAULT E STATUS (caso existir)
            groupProductId: 0,
            unitId: 0,
            modelId:0,
            issueDate: "",
            statusExecution: null,
            groupUserId: 0,
            operationStatusId: 0,
            processFlowStepId:[],
            statusBatch: 0,
        }

        this.form = Object.assign({}, formDefault,this.form);
    },
    methods:{

    }
}